import {
    RouterProvider,
    createBrowserRouter,
} from "react-router-dom";
import Header from "../component/header";
import Footer from "../component/footer";
import ScrollToTop from "../modules/scrolToTop";
import Catalog from "../component/catalog";
import CartPage from "../page/cartPage";
import AdminPanel from "../page/adminPanel";
import { createContext} from "react";
import { AppProvider } from "./Context";

function Basa({ children }) {
    return (
        <ScrollToTop>
            <Header />
            {children}
            <Footer />
        </ScrollToTop>
    );
}

const AppContext = createContext();

export function AppRouste() {

    

    const router = createBrowserRouter([
        {
            path: "/",
            element: (
                <Basa>
                    <Catalog />
                </Basa>
            ),
        },
        {
            path: "/kvartiry/:id",
            element: (
                <Basa>
                    <CartPage />
                </Basa>
            ),
        },
        {
            path: "/admin_panel",
            element: (
                <>
                   
                        <AdminPanel/>
                    
                </>
            ),
        },
    ]);

    

    return (
       <AppProvider>
         <RouterProvider router={router} />
       </AppProvider>
    );
}
